var _rect, _circle, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _g, _path3, _path4, _path5, _path6, _circle2, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataFount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 298,
    viewBox: "0 0 1440 848",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 298,
    fill: "#FFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 730.44,
    cy: 366.525,
    r: 163.525,
    fill: "#E8E8E8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 651.119,
    y: 253.034,
    width: 164.746,
    height: 207.458,
    rx: 18.3051,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 664.542,
    y: 281.102,
    width: 67.1186,
    height: 12.2034,
    rx: 6.1017,
    fill: "#666666"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 664.542,
    y: 317.712,
    width: 134.237,
    height: 12.2034,
    rx: 6.1017,
    fill: "#E8E8E8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 664.542,
    y: 354.322,
    width: 134.237,
    height: 12.2034,
    rx: 6.1017,
    fill: "#E8E8E8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 664.542,
    y: 390.932,
    width: 134.237,
    height: 12.2034,
    rx: 6.1017,
    fill: "#E8E8E8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 664.542,
    y: 427.542,
    width: 134.237,
    height: 12.2034,
    rx: 6.1017,
    fill: "#E8E8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M843.567 431.203L904.4 491.225C909.763 496.516 909.821 505.153 904.529 510.515C899.238 515.878 890.602 515.936 885.239 510.645L824.406 450.623L843.567 431.203Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M895.966 482.903L904.4 491.225C909.763 496.516 909.821 505.153 904.53 510.515C899.238 515.878 890.602 515.936 885.239 510.645L876.805 502.323L895.966 482.903Z",
    fill: "#B2B2B2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_758_2493)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 779.864,
    cy: 385.441,
    r: 81.1525,
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 779.864,
    cy: 385.441,
    r: 72,
    stroke: "#B2B2B2",
    strokeWidth: 18.3051
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M753.627 359.203L807.322 412.898",
    stroke: "#666666",
    strokeWidth: 17.0847,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M807.322 359.203L753.627 412.898",
    stroke: "#666666",
    strokeWidth: 17.0847,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M636.56 350.021C634.72 350.668 561.543 379.595 567.871 343.817C574.2 308.038 631.637 363.188 594.904 393.449C565.517 417.658 529.946 402.782 524 402.755",
    stroke: "#666666",
    strokeWidth: 1.22034,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M850 309.73C851.183 307.939 894.103 285.759 894.083 299.231C894.059 315.539 858.418 289.934 869.753 273.077C878.475 260.106 894.297 257.412 915.201 264.786",
    stroke: "#666666",
    strokeWidth: 1.22034,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 815.475,
    cy: 546.475,
    r: 16.4746,
    fill: "#E8E8E8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M615.255 611.344L627.095 629.456H627.159V611.344H630.327V634H626.327L614.359 615.504H614.295V634H611.127V611.344H615.255ZM651.046 626.384C651.046 631.056 647.494 634.416 642.854 634.416C638.214 634.416 634.694 631.056 634.694 626.384C634.694 621.712 638.214 618.416 642.854 618.416C647.494 618.416 651.046 621.712 651.046 626.384ZM647.91 626.384C647.91 623.504 646.118 620.912 642.854 620.912C639.622 620.912 637.798 623.504 637.798 626.384C637.798 629.264 639.622 631.888 642.854 631.888C646.118 631.888 647.91 629.264 647.91 626.384ZM663.377 634V611.344H671.153C676.945 611.344 683.377 614.64 683.377 622.672C683.377 630.416 676.945 634 671.153 634H663.377ZM666.545 614.096V631.216H670.513C675.985 631.216 679.985 628.08 679.985 622.672C679.985 617.072 675.985 614.096 670.513 614.096H666.545ZM697.001 624.592V624.176C697.001 621.936 695.497 620.848 693.257 620.848C691.561 620.848 689.961 621.584 688.937 622.608L687.337 620.688C688.809 619.28 691.081 618.416 693.545 618.416C697.897 618.416 699.881 621.008 699.881 624.368V630.992C699.881 632.016 699.945 633.264 700.105 634H697.385C697.225 633.328 697.129 632.528 697.129 631.824H697.033C695.945 633.456 694.217 634.384 691.945 634.384C689.545 634.384 686.441 633.2 686.441 629.712C686.441 625.136 691.881 624.592 697.001 624.592ZM697.001 626.768H696.265C693.289 626.768 689.513 627.088 689.513 629.648C689.513 631.44 691.113 632.016 692.617 632.016C695.433 632.016 697.001 630.128 697.001 627.568V626.768ZM712.016 618.832V621.296H707.984V629.2C707.984 631.024 708.624 631.76 710.128 631.76C710.672 631.76 711.376 631.632 711.888 631.376L711.984 633.84C711.28 634.096 710.352 634.256 709.424 634.256C706.576 634.256 705.008 632.656 705.008 629.52V621.296H702.096V618.832H705.008V614.48H707.984V618.832H712.016ZM724.563 624.592V624.176C724.563 621.936 723.059 620.848 720.819 620.848C719.123 620.848 717.523 621.584 716.499 622.608L714.899 620.688C716.371 619.28 718.643 618.416 721.107 618.416C725.459 618.416 727.443 621.008 727.443 624.368V630.992C727.443 632.016 727.507 633.264 727.667 634H724.947C724.787 633.328 724.691 632.528 724.691 631.824H724.595C723.507 633.456 721.779 634.384 719.507 634.384C717.107 634.384 714.003 633.2 714.003 629.712C714.003 625.136 719.443 624.592 724.563 624.592ZM724.563 626.768H723.827C720.851 626.768 717.075 627.088 717.075 629.648C717.075 631.44 718.675 632.016 720.179 632.016C722.995 632.016 724.563 630.128 724.563 627.568V626.768ZM743.795 623.888V634H740.627V611.344H754.771V614.128H743.795V621.168H754.067V623.888H743.795ZM772.483 626.384C772.483 631.056 768.931 634.416 764.291 634.416C759.651 634.416 756.131 631.056 756.131 626.384C756.131 621.712 759.651 618.416 764.291 618.416C768.931 618.416 772.483 621.712 772.483 626.384ZM769.347 626.384C769.347 623.504 767.555 620.912 764.291 620.912C761.059 620.912 759.235 623.504 759.235 626.384C759.235 629.264 761.059 631.888 764.291 631.888C767.555 631.888 769.347 629.264 769.347 626.384ZM790.191 634H787.343C787.279 633.232 787.215 632.144 787.215 631.504H787.151C786.383 633.104 784.399 634.416 782.191 634.416C778.286 634.416 776.527 631.632 776.527 628.24V618.832H779.535V627.216C779.535 629.712 780.207 631.888 782.991 631.888C785.391 631.888 787.055 629.904 787.055 626.896V618.832H790.062V630.736C790.062 631.536 790.095 633.008 790.191 634ZM795.152 618.832H798C798.064 619.6 798.128 620.688 798.128 621.328H798.224C798.96 619.696 800.976 618.416 803.152 618.416C807.056 618.416 808.816 621.2 808.816 624.592V634H805.808V625.584C805.808 623.12 805.136 620.944 802.352 620.944C799.984 620.944 798.288 622.928 798.288 625.936V634H795.28V622.096C795.28 621.296 795.248 619.824 795.152 618.832ZM826.001 631.6C824.849 633.424 822.673 634.416 820.529 634.416C815.857 634.416 812.881 630.832 812.881 626.384C812.881 621.904 815.953 618.416 820.497 618.416C822.961 618.416 824.849 619.632 825.905 621.104H825.969V609.808H828.977V634H826.065V631.6H826.001ZM816.016 626.384C816.016 629.232 817.745 631.888 821.041 631.888C824.113 631.888 826.161 629.328 826.161 626.416C826.161 623.504 824.113 620.912 821.041 620.912C817.745 620.912 816.016 623.536 816.016 626.384Z",
    fill: "#666666"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_758_2493",
    x: 696.712,
    y: 302.288,
    width: 166.305,
    height: 166.305,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_758_2493"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_758_2493",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataFount);
export default __webpack_public_path__ + "static/media/noDataFount.a88a2b23015b05887117e1bbbc9233a1.svg";
export { ForwardRef as ReactComponent };